import { EventEmitter }                   from '@angular/core';
import { ArchivingImportStatusEnum }      from '@app/modules/archiving/models/archiving-import.model';
import { BusinessPremisesStatusEnum }     from '@app/modules/business-premises/models/business-premises.model';
import { ErsStatusEnum }                  from '@app/modules/ers/models/ers.model';
import { OrganizationStatusEnum }         from '@app/modules/organization/models/organization.model';
import { ImportSetStatusEnum }            from '@app/modules/structure-import/models/structure-import.model';
import {
	IBaseHttpParams,
	RequestCompleteListState
}                                         from '@core/interfaces/api.interface';
import { ENTITY_TYPE }                    from '@core/interfaces/entity.interface';
import { PresetType }                     from '@models/preset';
import { ApplicationScopeTypes }          from '@models/scope.enums';
import { PlacementArray }                 from '@ng-bootstrap/ng-bootstrap/util/positioning';
import { IFilterInfo }                    from '@shared/list-operations/components/filter-info/filter-info.model';
import {
	FilterSortType,
	ISortFilter
}                                         from '@shared/list-operations/components/sort-filter/sort-filter.model';
import { ManagedObjectTypeEnum }          from '@shared/models/managed-object.model';
import { GlobalStatisticEnvironmentEnum } from '@shared/overview/statistics.model';
import { Observable }                     from 'rxjs';

// ENUMS ##########################################################
export enum FilterTypes {
	FILTER_DATE_PICKER_TYPE = 'FilterDatepickerType',
	FILTER_DATE_RANGE_PICKER_TYPE = 'FilterDateRangePickerType',
	FILTER_LIST_TYPE = 'FilterListType',
	FILTER_OPTION_TYPE = 'FilterOptionType',
	FILTER_SEARCH_TYPE = 'FilterSearchType',
	FILTER_SELECT_ARCHIVING_ERS_TYPE = 'FilterSelectArchivingErsType',
	FILTER_SELECT_ARCHIVING_KEYWORD_TYPE = 'FilterSelectArchivingKeywordType',
	FILTER_SELECT_ARCHIVING_TSS_TYPE = 'FilterSelectArchivingTssType',
	FILTER_SELECT_BUSINESS_PREMISES_TYPE = 'FilterSelectBusinessPremisesType',
	FILTER_SELECT_CONTRACT_TYPE = 'FilterSelectContractType',
	FILTER_SELECT_ERS_TYPE = 'FilterSelectErsType',
	FILTER_SELECT_ORGANIZATION_TYPE = 'FilterSelectOrganizationType',
	FILTER_SELECT_STATIC_ITEMS_TYPE = 'FilterSelectStaticItemsType',
	FILTER_SELECT_TENANT_TYPE = 'FilterSelectTenantType',
	FILTER_SELECT_TSS_TYPE = 'FilterSelectTssType',
	FILTER_SORT_TYPE = 'FilterSortType',
	FILTER_SWITCH_TYPE = 'FilterSwitchType',
	FILTER_TEXT_TYPE = 'FilterTextType'
}


export enum FilterIdentifiersEnum {
	ARCHIVING_CONTRACT_ID = 'archivingContractId',
	ASSIGNMENT = 'assignment',
	BUSINESS_DATE = 'businessDate',
	BUSINESS_DATE_FROM = 'businessDateFrom',
	BUSINESS_DATE_TO = 'businessDateTo',
	BUSINESS_PREMISES_ID = 'businessPremisesId',
	BUSINESS_PREMISES_IDS = 'businessPremisesIds',
	CONTRACT_ID = 'contractId',
	CONTRACT_IDS = 'contractIds',
	CONTRACT_LOG_PERIOD = 'contractLogPeriod',
	CONTRACT_MONTH = 'contractMonth',
	CONTRACT_TYPE = 'contractType',
	CONTRACT_TYPE_GROUP = 'contractTypeGroup',
	COUNT_LOWER_BOUNDARY = 'countLowerBoundary',
	COUNT_UPPER_BOUNDARY = 'countUpperBoundary',
	CREATED_DATE = 'createdDate',
	CREATED_DATE_FROM = 'createdDateFrom',
	CREATED_DATE_TO = 'createdDateTo',
	CUSTOMER_IDENTIFIER = 'customerIdentifier',
	CUSTOMER_NAME = 'customerName',
	DATA_CENTER_ENABLED = 'dataCenterEnabled',
	DATE = 'date',
	DOCUMENT_TYPE = 'documentType',
	ELSTER_CONTRACT_ID = 'elsterContractId',
	EMAIL = 'email',
	ENABLED = 'enabled',
	ENVIRONMENT = 'environment',
	ERS_ID = 'ersId',
	ERS_IDS = 'ersIds',
	ERS_SERIAL_NUMBER = 'ersSerialNumber',
	EXPORT_ID = 'exportId',
	EXPORT_MODE = 'exportMode',
	FAILED_TIME_PERIOD = 'failedTimePeriod',
	FCC_DATACENTER_CONTRACT_TYPE_GROUP = 'fccDataCenterContractTypeGroup',
	FCC_ID = 'fccId',
	FCC_IDS = 'fccIds',
	FCC_VERSION = 'fccVersion',
	FILTER = 'filter',
	FILTER_BODY = 'filterBody',
	FIRST_NAME_SEARCH = 'firstNameSearch',
	FISCAL_CONTRACT_ID = 'fiscalContractId',
	FORM_TYPE = 'formType',
	FROM = 'from',
	HAS_ERRORS = 'hasErrors',
	HAS_REASON = 'hasReason',
	HAS_VALIDATION_RESULTS = 'hasValidationResults',
	IMPORT_ID = 'importId',
	INCLUDE_OVER_MAX = 'includeOverMax',
	INCLUDE_TOTAL_COUNT = 'includeTotalCount',
	INSTALLATION_TYPE = 'installationType',
	IS_DOWNLOADED = 'isDownloaded',
	IS_NOT_YET_TAX_REPORTED = 'isNotYetTaxReported',
	KEYWORD_IDS = 'keywordIds',
	LAST_EVENT_DATE = 'lastEventDate',
	LAST_EVENT_DATE_FROM = 'lastEventDateFrom',
	LAST_EVENT_DATE_TO = 'lastEventDateTo',
	LAST_NAME_SEARCH = 'lastNameSearch',
	MANAGED_OBJECT_ID = 'managedObjectId',
	MANAGED_OBJECT_TYPE = 'managedObjectType',
	MODE = 'mode',
	NAME = 'name',
	NAME_SEARCH = 'nameSearch',
	NOTIFICATION_DATE = 'notificationDate',
	ORGANIZATION_ID = 'organizationId',
	ORGANIZATION_IDS = 'organizationIds',
	PROJECT_NUMBER = 'projectNumber',
	PROCEDURAL_DOCUMENTATION_ID = 'proceduralDocumentationId',
	READ = 'read',
	REQUIRED_TENANT_ID = 'requiredTenantId',
	ROLE = 'role',
	SEARCH = 'search',
	SCOPE = 'scope',
	SORT = 'sort',
	STATUS = 'status',
	SUSPICIOUS = 'suspicious',
	TARGET_TYPE = 'targetType',
	TAXABLE_ENTITY = 'taxableEntity',
	TENANT_ID = 'tenantId',
	TENANT_IDS = 'tenantIds',
	TENANT_GROUP = 'tenantGroup',
	THRESHOLDS = 'thresholds',
	THRESHOLDS_CLOUD = 'thresholdsCloud',
	THRESHOLDS_OFFLINE = 'thresholdsOffline',
	THRESHOLDS_SWISSBIT_TOKEN = 'thresholdsSwissbitToken',
	THRESHOLDS_TOKEN_CV1 = 'thresholdsTokenCv1',
	THRESHOLDS_TOKEN_CV2 = 'thresholdsTokenCv2',
	TO = 'to',
	TSS_ID = 'tssId',
	TSS_IDS = 'tssIds',
	TYPE = 'type',
	UPLOAD_TIME_FROM = 'uploadTimeFrom',
	UPLOAD_TIME_TO = 'uploadTimeTo',
	USER_NAME = 'userName',
	USER_NAME_SEARCH = 'userNameSearch',
	VALID_DATE = 'validDate',
	VALID_FROM = 'validFrom',
	VALID_TO = 'validTo',
}

export enum DateRangeFilterType {
	FROM,
	TO
}

export enum SelectFilterModeEnum {
	REQUESTED_LIST = 'requestedList',
	STATIC_LIST = 'staticList',
}


// DECLARATIONS ###################################################

// INTERFACES #####################################################
type ActiveFilterDataKeyType = Partial<Record<FilterIdentifiersEnum, IActiveFilterData>>;

export interface IActiveFilterData {
	param: FilterValueType;
	restoreValue?: string | FilterValueType;
}

export interface ISelectFilterable {
	searchRequestCallback(
		searchRequestParams: IBaseHttpParams
	): Observable<RequestCompleteListState<ENTITY_TYPE>>;
}


// tslint:disable-next-line:no-empty-interface
export interface IActiveFilters extends ActiveFilterDataKeyType {
}

export interface IFilterProperties {
	[ key: string ]: any;
}

export interface IFiltersWithAsyncInit {
	filterId: number;
	isInitialized: boolean;
}


export interface IFilterBase {
	id?: number;

	order: number;

	isRendered?: boolean;

	isDisabled?: boolean;

	filterId: FilterIdentifiersEnum;

	type: FilterTypes;

	permissionConfig?: {
		requiredScope: ApplicationScopeTypes;
		revokeScopeOnManagedObjectTypes?: ManagedObjectTypeEnum[];
	};

	info?: IFilterInfo;
}

export interface IFilter extends IFilterBase {

	i18nPath: string;

	service?: any;  // should actually be strong-typed

	bindLabel?: string;

	bindValue?: string;

	groupBy?: string;

	prefix?: string;

	values?: FilterValueType[];

	selectFilter?: {
		/**
		 * obligated for `FILTER_SELECT_STATIC_ITEMS_TYPE`
		 */
		apiEndpointIdentifier?: string;
		items?: ENTITY_TYPE[];
		paramKey?: string;
		presetId?: PresetType;
		search?: string;
		searchActiveFilterKey?: string;
		searchRequestParams?: IBaseHttpParams;
		searchRestoreValue?: string | FilterValueType;
		searchRestoreValueKey?: string;
	};

	items?: IFilterItem[];

	resetEventEmitter?: EventEmitter<boolean>;

	properties?: IFilterProperties;

	tooltip?: {
		bindKey?: string;
		disabled?: boolean;
		openDelay?: number;
		placement?: PlacementArray;
	};
}

export interface IFilterItem {
	i18nPath?: string;
	value?: FilterValueType;
}


// TYPES ##########################################################
export type FilterType =
	IFilter |
	ISortFilter;

export type FilterValueType =
	FilterDatepickerType |
	FilterDateRangePickerType |
	FilterListType |
	FilterNumberType |
	FilterOptionType |
	FilterSearchType |
	FilterSelectType |
	FilterSelectArchivingErsType |
	FilterSelectArchivingKeywordType |
	FilterSelectArchivingTssType |
	FilterSelectErsType |
	FilterSelectOrganizationType |
	FilterSelectTssType |
	FilterSortType |
	FilterSwitchType |
	FilterTextType;

export type FilterDatepickerType = Date;

export type FilterDateRangePickerType = Date[];

export type FilterListType =
	string[] |
	number[] |
	boolean[] |
	OrganizationStatusEnum[] |
	BusinessPremisesStatusEnum[] |
	ErsStatusEnum[] |
	ImportSetStatusEnum[] |
	ArchivingImportStatusEnum[] |
	GlobalStatisticEnvironmentEnum[];

export type FilterNumberType = number;

export type FilterOptionType =
	boolean |
	string;

export type FilterSelectType = ENTITY_TYPE | string;
export type FilterSelectArchivingErsType = string;
export type FilterSelectArchivingKeywordType = string;
export type FilterSelectArchivingTssType = string;
export type FilterSelectErsType = string[] | string;
export type FilterSelectOrganizationType = string[] | string;
export type FilterSelectTssType = string[] | string;

export type FilterTextType = string;

export type FilterSearchType = string;

export type FilterSwitchType = boolean;

// CLASSES ########################################################
